// ============================================================================
// Schnellkalkulation — Standalone PV-Kosten-Kalkulation ohne Projekt-Kontext
// ----------------------------------------------------------------------------
// Transient — kein Persist, kein Angebot. Stage 2 (Speichern/Varianten) nur
// im Projekt-Tab verfügbar. Alle Engine-Invarianten gelten: ENTWURF, kein
// canApprove, requiresHumanReview. API: POST /costing/calculate (auditiert).
// ============================================================================
import { CostWorksheetPanel } from "./CostWorksheetPanel.js";

export function KalkulationPage() {
  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Schnellkalkulation</h1>
          <p className="page-subtitle">PV-Kostenabschätzung ohne Kundendaten · Kein Angebot · Interne Kalkulation</p>
        </div>
      </div>
      <CostWorksheetPanel />
    </div>
  );
}
